import React, { useMemo } from 'react';

import { calculateInvestmentAddSharesPricePerUnit } from 'app-components/forms/investment/investmentTransactionFormDisplay';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import QAmountField from 'components/QAmountField';

import { investmentTransactionEditFormHooks } from 'components/Forms/InvestmentTransactionEditForm/investmentTransactionEditFormHooks';
import { SecurityAndTagsFields } from './SecurityAndTagsFields';
import { handleNumericKeyDown, numberFromInput, useNumericTextField } from './utils';

export function AddSharesFields() {
  const costBasis = investmentTransactionEditFormHooks.useField('costBasis');
  const units = investmentTransactionEditFormHooks.useField('units');
  const unitsInput = useNumericTextField({ value: units.value, onValueChange: units.onValueChange });
  const pricePerUnit = useMemo(
    () => calculateInvestmentAddSharesPricePerUnit({ costBasis: costBasis.value, units: units.value }),
    [costBasis.value, units.value],
  );

  return (
    <>
      <SecurityAndTagsFields />
      <Box display='flex' alignItems='center' gap={1}>
        <QAmountField
          id='total-amount'
          editable
          label='Total Amount'
          sx={{ minWidth: 110 }}
          noNegatives
          value={Math.abs(costBasis.value ?? 0)}
          variant='filled'
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            costBasis.onValueChange(Math.abs(numberFromInput(event.target.value)))
          }
          error={costBasis.error}
          helperText={costBasis.helperText}
        />
        =
        <TextField
          id='units'
          label='Shares quantity'
          type='number'
          inputProps={{ min: 1, inputMode: 'decimal' }}
          sx={{ minWidth: 110 }}
          variant='filled'
          value={unitsInput.value}
          onKeyDown={handleNumericKeyDown}
          onChange={unitsInput.onChange}
          error={units.error}
          helperText={units.helperText}
        />
        x
        <QAmountField
          id='price-per-share'
          editable
          disabled
          InputProps={{ readOnly: true }}
          sx={{ minWidth: 110 }}
          expectedSign='positive'
          value={pricePerUnit}
          variant='filled'
          label='Price per share'
        />
      </Box>
    </>
  );
}
